<div *ngIf="message as m" class="preview-banner" role="status" aria-live="polite">
  <span class="preview-banner__badge">Preview</span>
  <span class="preview-banner__message">{{ m }}</span>
</div>
